<div class="card mb-0">
  <h5 class="card-header">
    Preview
  </h5>

  <div class="card-body">
    <p *ngIf="isLoading"> Loading....</p>
    <iframe class="image-preview" *ngIf="safeSrc != null" [src]="safeSrc"></iframe>
  </div>

  <div class="card-footer">
    <div class="row">
      <div class="col text-right">
        <button class="btn btn-default btn-primary submit" type="button" (click)="close('close')">Cancel</button>
      </div>
    </div>
  </div>
</div>